var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoVehicleTransportFinished(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 70,
    viewBox: "0 0 99 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.4748 57.3121C62.9202 53.4447 59.5856 50.4717 55.5548 50.4717C51.524 50.4717 48.1894 53.4447 47.6348 57.3121M63.4748 57.3121C66.2955 57.3121 68.3503 57.3121 69.6391 57.3121M63.4748 57.3121C63.5282 57.6845 63.5558 58.065 63.5558 58.4521C63.5558 62.8595 59.9736 66.4324 55.5548 66.4324C51.136 66.4324 47.5538 62.8595 47.5538 58.4521C47.5538 58.065 47.5814 57.6845 47.6348 57.3121M47.6348 57.3121H31.5518V41.3513H91.9209C93.1834 41.3513 94.2069 42.3722 94.2069 43.6314V55.0319C94.2069 56.2912 93.1834 57.3121 91.9209 57.3121C89.0219 57.3121 86.8477 57.3121 85.3982 57.3121",
    stroke: "#FFD4A3",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5518 67.2161C82.37 67.2161 86.2759 63.3561 86.2759 58.5945C86.2759 53.8329 82.37 49.9729 77.5518 49.9729C72.7336 49.9729 68.8276 53.8329 68.8276 58.5945C68.8276 63.3561 72.7336 67.2161 77.5518 67.2161Z",
    stroke: "#FFD4A3",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8434 57.3406C26.2823 53.4852 22.9079 50.5216 18.8291 50.5216C14.7503 50.5216 11.376 53.4852 10.8148 57.3406L3.79321 57.3405V39.1567L17.6725 20.9729H31.5518V57.3405L26.8434 57.3406ZM26.8434 57.3406C26.8974 57.7117 26.9254 58.0911 26.9254 58.477C26.9254 62.8706 23.3006 66.4324 18.8291 66.4324C14.3577 66.4324 10.7329 62.8706 10.7329 58.477C10.7329 58.0911 10.7608 57.7117 10.8148 57.3406",
    stroke: "#FFD4A3",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.241 35.7324C85.6228 38.3582 83.273 40.312 80.4686 40.312C77.6643 40.312 75.3145 38.3582 74.6963 35.7324",
    stroke: "#FFD4A3",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.3517 3.63187L89.6033 4.31109C90.2244 8.32807 90.2244 11.3307 89.6033 13.3189C88.6717 16.3012 86.7234 18.8663 84.0946 20.5722L83.5603 20.9179L83.6625 21.1763L90.4442 24.8746C91.326 25.3555 91.875 26.2821 91.875 27.2896V31.1514C91.875 33.681 89.8323 35.7318 87.3125 35.7318L86.2411 35.7325C86.345 35.2912 86.4 34.8309 86.4 34.3576C86.4 31.0691 83.7445 28.4031 80.4688 28.4031C77.193 28.4031 74.5375 31.0691 74.5375 34.3576C74.5375 34.8309 74.5925 35.2912 74.6964 35.7325H54.3036C53.6854 38.3583 51.3356 40.3122 48.5312 40.3122C45.7269 40.3122 43.3771 38.3583 42.7589 35.7325L41.6875 35.7318C39.1677 35.7318 37.125 33.681 37.125 31.1514V28.9984C37.125 27.5269 38.0018 26.1981 39.3515 25.6243L49.3994 21.3518C49.7264 21.2371 50.0141 21.0315 50.229 20.7589L55.008 14.6951C56.3925 12.9383 58.5014 11.9137 60.7328 11.9137L72.8667 11.9152C72.5852 10.0099 72.6891 7.47515 73.1783 4.31109L75.43 3.63187C79.3165 2.45995 83.4648 2.45995 87.3517 3.63187Z",
    stroke: "#FFD4A3",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3037 35.7325C54.4076 35.2911 54.4626 34.8308 54.4626 34.3576C54.4626 31.069 51.8071 28.4031 48.5313 28.4031C45.2556 28.4031 42.6001 31.069 42.6001 34.3576C42.6001 34.8308 42.6551 35.2911 42.759 35.7325",
    stroke: "#FFD4A3",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8667 11.9153C72.9426 12.4289 73.0464 12.8968 73.1783 13.3189C74.0741 16.1866 75.9099 18.6684 78.3868 20.3717L78.6871 20.5723L80.4387 21.7089C80.9729 22.0556 81.6503 22.0823 82.2066 21.7889L82.3429 21.7089L83.5603 20.9179",
    stroke: "#FFD4A3",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9443 11.6569L81.0378 13.8131L85.8686 8.8374",
    stroke: "#FFD4A3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoVehicleTransportFinished);
export default __webpack_public_path__ + "static/media/ico_vehicle_transport_finished.51ea471aa2aa226bd475fd86e2fe8f6d.svg";
export { ForwardRef as ReactComponent };